<div class="modal-header py-2 bg-light">
  <h5 class="modal-title">{{ 'common.exportExcel' | transloco }}</h5>
  <button type="button" class="btn-close" [attr.aria-label]="'common.close' | transloco"
          (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body bg-light p-0" *transloco="let t">
  <div class="bg-white" [class.mb-3]="!progressState.isFinal">
    <!--- Chọn dữ liệu ------------------------------------------------------------------>
    <div class="p-3 pb-1">
      <div class="row">
        <div class="col-xl-2 col-12 my-0">
          <label class="form-label fw-semibold">
            {{ t('common.selectData') }}:
          </label>
        </div>
        @if (options.excelListPage) {
          <div class="d-flex flex-wrap gap-3 col-xl-10 col-12">
            @for (page of options.excelListPage.list; track page) {
              <div class="me-xl-4 me-0">
                <app-checkbox
                  [options]="{
 componentType: 'form-switch',
 type: 'radio',
 name: 'isListPages',
 color: 'success'
 }"
                  [value]="page.key"
                  [label]="t(page.value)"
                  [checked]="page.key == state.pageSelection"
                  (valueChange)="state.pageSelection = $event"
                />
              </div>
            }
          </div>
        }
      </div>
    </div>
    <!--- End Chọn dữ liệu ------------------------------------------------------------------>

  </div>
  @if (!progressState.isExportSubmit) {
    @if (state.tabRef == 'excel') {
      <!---- Tên File ----->
      <div class="row w-100 p-3 pt-0">
        <div class="col-xl-6 col-12" data-title="Bảng tính">
          <h6 class="fw-semibold mb-2">{{ t('excel.worksheet') }}</h6>
          <app-floating-invalid class="flex-1" [errorOriginal]="errors['fileNew.fileName']">
            <input type="text"
                   class="form-control"
                   placeholder="Nhanh.vn_Order"
                   [class.border-danger]="!!errors['fileNew.fileName']"
                   [class.pe-4]="!!errors['fileNew.fileName']"
                   (ngModelChange)="onChangeValue('fileNew.fileName', $event)"
                   [(ngModel)]="state.fileNew.fileName">
          </app-floating-invalid>
        </div>
        <div class="col-xl-6 col-12" data-title="Trang tính">
          <h6 class="fw-semibold mt-3 mt-lg-0 mb-2">{{ t('excel.spreadsheet') }}</h6>
          <div class="d-flex align-items-center mb-2">
            <app-floating-invalid class="flex-1" [errorOriginal]="errors['fileNew.sheetName']">
              <input type="text"
                     class="form-control"
                     placeholder="Nhanh.vn_Order_y-m-d_h_i_s"
                     [class.border-danger]="!!errors['fileNew.sheetName']"
                     [class.pe-4]="!!errors['fileNew.sheetName']"
                     (ngModelChange)="onChangeFileSheetName($event)"
                     [(ngModel)]="state.fileNew.sheetName">
            </app-floating-invalid>
          </div>
        </div>
      </div>
    }
  }
  <app-export-data-columns [exportData]="this"/>
    <div class="bg-white w-100 p-3">
      <div class="d-lg-flex align-items-center justify-content-between">
        <!--- Process ------------------------------------------------------------------>
        @if (progressState.isExportSubmit && !progressState.isFinal) {
          <div
            class="d-flex flex-auto mb-3 mb-lg-0 me-lg-4">
            <p class="mb-0 me-3">
              <i class="ph ph-caret-up me-3"></i>
              {{ t('common.exportingData') }}:
              <span>{{ progressState.currentItem }}</span>
              @if (progressState.totalPages > 0) {
                / <span>{{ progressState.totalItems }}</span>
              }
            </p>
            <div class="flex-1">
              <app-progress-bar
                [totalPages]="progressState.totalPages"
                [currentPage]="progressState.currentPage"/>
            </div>
          </div>
        }
        <!--- End Process ------------------------------------------------------------------>
        <div class="d-flex flex-auto flex-lg-1 justify-content-end">
          @if (!progressState.isFinal) {
            <button type="button" class="btn btn-primary btn-sm text-nowrap fw-semibold"
                    [disabled]="progressState.isExportSubmit"
                    (click)="onExportData()">
              {{ t('common.exportData') }}
            </button>
          }
          <button type="button" class="btn btn-light btn-sm text-nowrap ms-3 fw-semibold"
                  (click)="activeModal.dismiss()">
            {{ t('common.close') }}
          </button>
        </div>
      </div>
    </div>
</div>
